<template>
  <div class="check-users-warp">
    <div class="check-users">
      <div v-for="(account, index) in checkList" :key="index" class="check-users-item" :style="itemStyle">
        <account-avatar :account="account" width="30px" height="30px" />
        <span>{{ account.im_name }}</span>
      </div>
      <slot name="check-users-item-add" :itemStyle="itemStyle"></slot>
    </div>
  </div>
</template>

<script>
import AccountAvatar from '../AccountAvatar'
export default {
  name: 'CheckUsersWarp',
  components: { AccountAvatar },
  props: {
    checkList: {
      type: Array,
      default: () => {
        return []
      }
    },
    flexBasis: {
      type: String,
      default: '33.3%'
    }
  },
  computed: {
    itemStyle () {
      return {
        flex: `1 0 ${this.flexBasis}`,
        maxWidth: this.flexBasis
      }
    }
  },
  watch: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.check-users-warp {
  flex-grow: 1;
  margin-top: 20px;
  overflow-y: auto;
}
.check-users {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
}
.check-users-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  //flex: 1 0 33.3%;
  //max-width: 33.3%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/CheckUsersWarp.vue